import { ArticleHeading4 } from '@cian/ui-kit/typography';
import * as React from 'react';

import * as styles from './styles.css';

export function PromoHeader() {
  return (
    <div className={styles['container']}>
      <ArticleHeading4>Акции</ArticleHeading4>
    </div>
  );
}
